
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronLeft, Save, Play, Maximize, Minimize } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface PolicyFlowHeaderProps {
  policyId?: number;
  fullscreen: boolean;
  toggleFullscreen: () => void;
  handleSave: () => void;
  handleRun: () => void;
}

export const PolicyFlowHeader = ({ 
  policyId, 
  fullscreen, 
  toggleFullscreen, 
  handleSave, 
  handleRun 
}: PolicyFlowHeaderProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleBack = () => {
    navigate('/policies');
  };

  return (
    <div className="border-b p-4 flex justify-between items-center">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={handleBack}>
          <ChevronLeft className="h-5 w-5" />
        </Button>
        <h1 className="text-xl font-semibold">
          {policyId ? 'Edit Policy Flow' : 'Create Policy Flow'}
        </h1>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={toggleFullscreen}>
          {fullscreen ? (
            <Minimize className="h-5 w-5" />
          ) : (
            <Maximize className="h-5 w-5" />
          )}
        </Button>
        <Button variant="outline" onClick={handleRun} className="flex items-center gap-1">
          <Play className="h-4 w-4" />
          <span className={isMobile ? 'sr-only' : ''}>Run</span>
        </Button>
        <Button onClick={handleSave} className="flex items-center gap-1">
          <Save className="h-4 w-4" />
          <span className={isMobile ? 'sr-only' : ''}>Save</span>
        </Button>
      </div>
    </div>
  );
};
